import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Output,
} from "@angular/core";

@Directive({ selector: "[appDragDrop]" })
export class DragDropDirective {
  @Output() fileDropped = new EventEmitter<File>();
  /** Emits true while a file is dragged over the host, false on leave/drop. */
  @Output() dragHover = new EventEmitter<boolean>();

  @HostBinding("class.drag-hover") isHovering = false;

  @HostListener("dragover", ["$event"])
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (!this.isHovering) {
      this.isHovering = true;
      this.dragHover.emit(true);
    }
  }

  @HostListener("dragleave", ["$event"])
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isHovering) {
      this.isHovering = false;
      this.dragHover.emit(false);
    }
  }

  @HostListener("drop", ["$event"])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (this.isHovering) {
      this.isHovering = false;
      this.dragHover.emit(false);
    }
    if (event.dataTransfer?.files.length) {
      this.fileDropped.emit(event.dataTransfer.files[0]);
    }
  }
  constructor() {}
}
